import * as moment from 'moment';

export const DateToString = function (date: Date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
};

export const DateToStringUtc = function (date: Date) {
  return moment(date).format();
};
